import PropTypes from 'prop-types';

import LoginForm from '../components/users/LoginForm';

const Login = ({ previousLocation }) => {
    return <LoginForm previousLocation={previousLocation} />;
};

Login.propTypes = {
    previousLocation: PropTypes.string,
};

export default Login;
